<template>
  <div class="login">
    <div
      v-if="!forgotDialog"
      class="login-container flex flex-direction-column flex-jc-center flex-ai-center"
    >
      <div class="content-center flex flex-direction-column">
        <img
          :class="[
            'logo-img flex flex-self-center',
            isQRCode ? 'mt-36 ' : 'mt-60'
          ]"
          src="../assets/images/logo.png"
        />

        <slot v-if="isQRCode">
          <div class="login-qrcode-conetnt">
            <img src="../assets/images/qrcode.png" />
          </div>
        </slot>
        <slot v-else>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
          >
            <el-form-item prop="username">
              <el-dropdown
                v-if="recentLogins.length > 0"
                trigger="click"
                :placement="'bottom-end'"
                :append-to-body="false"
                @command="handleCommand"
              >
                <el-input
                  class="dark-input"
                  v-model.trim="loginForm.username"
                  type="text"
                  autocomplete="off"
                  :placeholder="$t('placeholder.login_username')"
                >
                  <svg-icon slot="prefix" icon-class="user" class="my-icon" />
                </el-input>
                <!-- tbb-dropdown-menu login-dropdown -->
                <el-dropdown-menu slot="dropdown" class="">
                  <el-dropdown-item
                    :command="item"
                    v-for="(item, index) in recentLogins"
                    :key="index"
                  >
                    {{ item }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-input
                v-else
                class="dark-input"
                v-model.trim="loginForm.username"
                type="text"
                autocomplete="off"
                :placeholder="$t('placeholder.login_username')"
              >
                <svg-icon slot="prefix" icon-class="user" class="my-icon" />
              </el-input>
            </el-form-item>

            <el-form-item prop="password">
              <!-- :autocomplete="passwordType ? 'off' : 'new-password'" -->

              <el-input
                class="dark-input"
                v-model.trim="loginForm.password"
                :type="passwordType ? 'text' : 'password'"
                :placeholder="$t('placeholder.login_password')"
                :autocomplete="passwordType ? 'off' : 'new-password'"
                @keyup.enter.native="handleLogin"
              >
                <svg-icon slot="prefix" icon-class="password" class="my-icon" />
                <svg-icon
                  v-if="loginForm.password && !passwordType"
                  slot="suffix"
                  icon-class="close-eyes"
                  class="my-icon-eyes cursor-pointer"
                  @click="passwordType = true"
                />
                <svg-icon
                  v-if="loginForm.password && passwordType"
                  slot="suffix"
                  icon-class="eyes"
                  class="my-icon-eyes cursor-pointer"
                  @click="passwordType = false"
                />
              </el-input>
            </el-form-item>
          </el-form>

          <el-checkbox
            v-model="loginForm.rememberMe"
            @change="handleCheckboxChange"
            :class="[
              'login-checkbox',
              isRemenber ? 'is-remember-top' : 'is-remember'
            ]"
          >
            {{ $t('login.login_remember') }}
          </el-checkbox>
          <el-button
            class="login-btn"
            :loading="loading"
            type="lightblue"
            @click="handleLogin"
          >
            {{ $t('login.login') }}
          </el-button>
        </slot>

        <p
          v-if="isQRCode"
          class="login-text text-d-underline cursor-pointer mt-16 mb-28"
          @click="isQRCode = !isQRCode"
        >
          {{ $t('login.password_login') }}
        </p>
        <div v-else>
          <p
            class="login-text text-d-underline font-color-gray cursor-pointer mt-24"
            @click="forgotDialog = !forgotDialog"
          >
            {{ $t('login.forgot_password') }}
          </p>
          <p class="login-text font-color-gray mt-16">
            {{ $t('version.version') }}
          </p>
        </div>
        <!-- 二维码 -->
        <svg-icon
          v-if="!isQRCode"
          class="login-qr-code font-24"
          icon-class="qr"
          @click.prevent="isQRCode = !isQRCode"
        />

        <div
          v-if="!isQRCode"
          class="login-show-code"
          @click.stop="isQRCode = !isQRCode"
        ></div>
      </div>
      <a
        class="login-dec text-d-underline mt-24 font-12 cursor-pointer font-color-gray"
        href="https://www.tbbpowermobile.com/"
        target="_blank"
      >
        {{ $t('login.login_dec') }}
      </a>
    </div>

    <ForgotPasswordDialog
      v-else
      :show="forgotDialog"
      @cancel="handleCancel"
      @confirm="handelConfirm"
    />
    <OtherFooter />
  </div>
</template>

<script>
import { forgetUserPassword } from '@/api/user'
import { encrypt, decrypt } from '@/utils/jsencrypt'
import { validateUsername } from '@/utils/form/rule'
import ForgotPasswordDialog from '@/components/TbbDialog/ForgotPasswordDialog'
import OtherFooter from '@/components/TbbFooter/OtherFooter'
import { mapGetters } from 'vuex'




export default {
  name: 'Login',
  components: {
    ForgotPasswordDialog,
    OtherFooter
  },
  computed: {
    ...mapGetters(['roleKey'])
  },
  data() {
    const that = this
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        this.isRemenber = false

        callback(new Error(that.$t('rules.warning_empty_passwd')))
      } else if (/[\u4e00-\u9fa5]/.test(value)) {
        this.isRemenber = false
        callback(new Error(that.$t('rules.error_password_message')))
      } else if (value.length > 30) {
        this.isRemenber = false
        callback(new Error(that.$t('rules.warning_max_passwd')))
      } else {
        this.isRemenber = true
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      loginRules: {
        username: [
          { required: true, trigger: 'change', validator: validateUsername }
          // {
          //   type: 'email',
          //   message: that.$t('rules.email_invalid'),
          //   trigger: 'change'
          // }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      isQRCode: false,
      isRemenber: true,
      loading: false,
      passwordType: false,
      forgotDialog: false,
      redirect: undefined,
      token: undefined,
      recentLogins: []
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.token = this.$route.query.token
    if (this.token) {
      this.loginByToken()
    }
    this.loadRecentLogins()

    this.getSession()
  },
  methods: {
    loginByToken() {
      this.loginForm = {
        grant_type: 'ldap_sso',
        token: this.token
      }
      this.loginFun()
    },
    handleCommand(command) {
      this.loginForm.username = command
      let username = localStorage.getItem('tbb_username')
      let password = decrypt(localStorage.getItem('tbb_password'))

      if (username && password && username == command) {
        this.loginForm.password = password
        this.loginForm.rememberMe = true
      } else {
        this.loginForm.password = ''
        this.loginForm.rememberMe = false
      }
      localStorage.setItem('tbb_rememberMe', this.loginForm.rememberMe)
    },
    handleCheckboxChange() {
      localStorage.setItem('tbb_rememberMe', this.loginForm.rememberMe)
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.loginForm.rememberMe) {
            localStorage.setItem('tbb_username', this.loginForm.username)
            localStorage.setItem(
              'tbb_password',
              encrypt(this.loginForm.password)
            )
            localStorage.setItem('tbb_rememberMe', this.loginForm.rememberMe)
          } else {
            localStorage.removeItem('tbb_username')
            localStorage.removeItem('tbb_password')
            localStorage.removeItem('tbb_rememberMe')
          }
          this.loginFun()
        }
      })
    },
    loginFun() {
      this.$store
        .dispatch('Login', this.loginForm)
        .then((code) => {
          if (code == 200) {
            this.$store.dispatch('GetInfo').then(() => {
              this.$store.dispatch('GenerateRoutes').then((accessRoutes) => {
                if (this.roleKey == 0) {
                  this.$router.push({ path: '/users/account/index' })
                }else if (this.roleKey == 1) {
                  this.$router.push({ path: '/users/account/index' })
                }else if (this.roleKey == 2) {
                  this.$router.push({ path: '/device/sn-list/index' })
                } else {
                  this.$router.push({ path: '/setting/set' })
                }

                this.saveRecentLogin(this.loginForm.username)

                let timer = setTimeout(() => {
                  this.loading = false
                  clearTimeout(timer)
                }, 1000)
              })
            })
          }
        })
        .catch(() => {
          this.$store.dispatch('LogOut').then(() => {
            // Message.error(err)
            this.$router.push({ path: '/login' })
            this.loading = false
          })
        })
    },
    saveRecentLogin(username) {
      localStorage.setItem(
        'recentLogins',
        JSON.stringify(
          [
            username,
            ...this.recentLogins.filter((login) => login !== username)
          ].slice(0, 5)
        )
      )
      this.recentLogins = [
        username,
        ...this.recentLogins.filter((login) => login !== username)
      ].slice(0, 5)
    },
    loadRecentLogins() {
      const recentLogins = localStorage.getItem('recentLogins')
      if (recentLogins) {
        try {
          this.recentLogins = JSON.parse(recentLogins)
        } catch (e) {
          localStorage.removeItem('recentLogins')
        }
      }
    },
    // 关闭忘记密码弹框
    handleCancel(val) {
      this.forgotDialog = val
    },
    // 确认忘记密码
    handelConfirm(form) {
      const params = {
        account: form.email,
        verificationCode: form.code,
        newPassword: form.againPassword
      }
      forgetUserPassword(params).then((res) => {
        if (res) {
          this.$message({
            message: this.$t('message.forget_success_message_info'),
            type: 'success'
          })
          this.$store.dispatch('setDialogConfirmBtn', false)

          this.forgotDialog = false
        }
      })
    },
    getSession() {
      const username = localStorage.getItem('tbb_username')
      const password = localStorage.getItem('tbb_password')
      const rememberMe = localStorage.getItem('tbb_rememberMe')
      this.loginForm = {
        username: username ? username : this.loginForm.username,
        password: password ? decrypt(password) : this.loginForm.password,
        rememberMe: rememberMe ? Boolean(rememberMe) : this.loginForm.rememberMe
      }
    }
  }
}
</script>

<style lang="scss">
.login {
  position: relative;
  height: 100vh;
}
.login-container {
  height: 100%;
  position: relative;
  .content-center {
    position: relative;
    width: 340px;
    height: 426px;
    background: rgba(255, 255, 255, 0.1);
    // background: hsla(0, 0%, 100%, 0.2);
    backdrop-filter: blur(20px); /* 背景模糊 */
    -webkit-backdrop-filter: blur(20px); /* 兼容老版本 Safari */
    -moz-backdrop-filter: blur(20px); /* 兼容老版本 Safari */

    box-shadow: inset 0.5px 0.5px 0.5px 0.5px rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 0px 40px 0px 40px;
    .logo-img {
      width: 164px;
      height: 36px;
      object-fit: fill;
    }
  }
  .login-form {
    margin-top: 30px;
  }
  .dark-input {
    width: 260px;

    .el-input__inner {
      background-color: #272a32 !important;
      padding-left: 36px !important;
      &::placeholder {
        color: #656565;
        font-family: HARMONYOS_SANS_REGULAR;
        font-size: 10px;
      }
    }
    .el-input__prefix {
      top: 2px;
    }

    .my-icon {
      font-size: 28px;
      line-height: 46px;
      color: #656565;
    }
    .my-icon-eyes {
      font-size: 20px;
      margin-top: 8px;
      color: #656565;
    }
  }
  .login-qrcode-conetnt {
    width: 260px;
    height: 260px;
    backdrop-filter: blur(20px); /* 背景模糊 */
    -webkit-backdrop-filter: blur(20px); /* 兼容老版本 Safari */
    -moz-backdrop-filter: blur(20px); /* 兼容老版本 Safari */

    background: rgb(30, 33, 41);
    border-radius: 6px;
    margin-top: 24px;
    padding: 36px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login-checkbox {
    margin-bottom: 18px;
    color: #999999;

    .el-checkbox__input {
      .el-checkbox__inner {
        background-color: rgba(102, 102, 102, 0.42);
        border: 1px solid #999999;
      }
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #999999;
    }
  }
  .is-remember-top {
    margin-top: -6px;
  }
  .is-remember {
    margin-top: 12px;
  }
  .login-text {
    text-align: center;
  }
  .login-qr-code {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .login-btn {
    font-family: HARMONYOS_SANS_BLACK;
  }
  .login-show-code {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-right: 20px solid rgba(153, 153, 153, 0.3);
    border-bottom: 20px solid rgba(153, 153, 153, 0.3);
    border-left: 20px solid transparent;
    border-top: 20px solid transparent;
    transform: rotate(90deg);
    border-bottom-right-radius: 6px;
  }
}
</style>
